import { IconType } from 'react-icons';
import {
  FaGithub,
  FaGoogle,
  FaInstagram,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';
import { SiZenn } from 'react-icons/si';
import type { SocialId } from '@/content/contact';

export const socialIcons: Record<SocialId | 'email', IconType> = {
  x: FaXTwitter,
  instagram: FaInstagram,
  zenn: SiZenn,
  github: FaGithub,
  youtube: FaYoutube,
  email: FaGoogle,
};
